module.exports = __webpack_public_path__ + "img/app_store.ac4df0d9.png";